module.exports = __webpack_public_path__ + "img/mobile_stopped.7c9cd365.svg";